import React, { Component } from 'react';
import styles from './TestCase.scss';
import { Alert, Button, notification, Tooltip, Spin } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { withTranslation } from 'react-i18next';
import StatusBox from '../UI/StatusBox/StatusBox';
import { LogoStatus } from '../../const';

class TestCase extends Component {
  constructor(props) {
    super(props);
    this.alertRef = React.createRef();
  }

  copy_to_clipboard = text => {
    const { t } = this.props;

    navigator.clipboard.writeText(text);
    notification.open({
      style: {
        marginLeft: '100px',
        width: '250px',
      },
      message: t('test_case.notification.copied'),
      duration: 2,
      icon: <CopyOutlined />,
    });
  };

  testCode = () => {
    this.props.testCode();
    if (this.alertRef && this.alertRef.current) {
      this.alertRef.current.scrollIntoView();
    }
  };

  render() {
    const { t } = this.props;

    let count = 0;
    const sampleCase =
      this.props.testcases.length !== 0
        ? this.props.testcases.map(tc => {
            if (tc.visible === true) {
              count++;
              return (
                <div key={tc.id}>
                  <h3 className="font-weight-medium">{t('test_case.sample_case', { count })}</h3>
                  <div className={styles.sample_io}>
                    <div className={styles.sample_io_div}>
                      <div className={styles.sample_io_header}>
                        <h4>{t('test_case.input')}</h4>
                        <Tooltip title={t('test_case.copy_tooltip')}>
                          <CopyOutlined
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.copy_to_clipboard(tc.stdin)}
                          />
                        </Tooltip>
                      </div>
                      <textarea
                        rows="4"
                        cols="50"
                        value={tc.stdin}
                        readOnly
                      />
                    </div>
                    <div style={{ width: '10px' }}></div>
                    <div className={styles.sample_io_div}>
                      <div className={styles.sample_io_header}>
                        <h4>{t('test_case.output')}</h4>
                        <Tooltip title={t('test_case.copy_tooltip')}>
                          <CopyOutlined
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.copy_to_clipboard(tc.stdout)}
                          />
                        </Tooltip>
                      </div>
                      <textarea
                        rows="4"
                        cols="50"
                        value={tc.stdout}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              );
            } else {
              return null;
            }
          })
        : t('test_case.select_problem');

    const outMessage = this.props.stdout + this.props.stderr;

    return (
      <div className={styles['c-custom-input__scrollbar']}>
        <div className={styles['c-custom-input']}>
          <p>
            <em>{t('test_case.custom_test_description')}</em>
          </p>

          <div ref={this.alertRef}></div>

          <StatusBox
            title={t('test_case.input_format_title')}
            onChange={this.props.setInput}
            value={this.props.stdin}
            data-testid="custom-input-box"
          >
            <div className={styles.custom_io_footer}>
              <Button
                className={styles.custom_io__Button}
                type="primary"
                ghost
                onClick={() => this.testCode()}
                data-testid="test-code-button"
                disabled={!this.props.stdin || this.props.isLoading}
                loading={this.props.isLoading}
              >
                {t('test_case.test_code')}
              </Button>
            </div>
          </StatusBox>

          {this.props.verdict && this.props.verdict.name !== LogoStatus.NotAttempted && (
            <>
              <StatusBox
                title={t('test_case.output_custom')}
                value={outMessage}
                readOnly={true}
                error={this.props.stderr}
                data-testid="custom-output-box"
              />

              {this.props.verdict.name === 'OK' ? (
                <Alert
                  className={styles.custom_io_alert}
                  message={t('test_case.run_code_hint')}
                  type="success"
                  showIcon
                  data-testid="custom-output-alert"
                />
              ) : (
                <Alert
                  className={styles.custom_io_alert}
                  message={this.props.verdict.name}
                  type={this.props.verdict.type}
                  showIcon
                  data-testid="custom-output-alert"
                />
              )}
            </>
          )}

          <p>
            <em>{t('test_case.sample_summary', { count })}</em>
          </p>

          {sampleCase}
        </div>
      </div>
    );
  }
}

export default withTranslation('interview_problem')(TestCase);
